import IState from 'services/state';
import { Clients, IUbisoftAdobe } from './models';
import { createSelector } from 'reselect';

export const getClient = (state:IState):Clients | null=>state.thirdPartyAnalytics.client;
export const getData = createSelector((state:IState)=> state.thirdPartyAnalytics.data,(data): IUbisoftAdobe | {} => data);
export const getActive = ({ thirdPartyAnalytics }: IState): boolean => (
  thirdPartyAnalytics.active
);
